module.exports = __webpack_public_path__ + "static/media/oneToOne.aaea53e6.mp3";